module.exports = __webpack_public_path__ + "static/about_simulator_cactus_art@2x-f939d647a59bd0f1571c67e53d9dca6e.png";